"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _reactModal = _interopRequireDefault(require("../../../components/reactModal"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var UnsavedChangesModal = function UnsavedChangesModal(_ref) {
  var showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      closeModal = _ref.closeModal,
      resetChanges = _ref.resetChanges;
  return (0, _preact.h)(_reactModal.default, {
    isOpen: showUnsavedChangesModal,
    onClose: function onClose() {
      return closeModal();
    }
  }, (0, _preact.h)("div", {
    className: "unsaved-changes-modal"
  }, (0, _preact.h)("h3", {
    className: "modal-title"
  }, "Unsaved Changes"), (0, _preact.h)("div", {
    className: "modal-description"
  }, "You have unsaved changes. Do you want to discard them?"), (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "brand",
    title: "Discard changes",
    onClick: function onClick() {
      return resetChanges();
    },
    "data-track-type": "click",
    "data-element-name": "Discard changes button"
  }), (0, _preact.h)(_Button.default, {
    size: "medium",
    title: "Cancel",
    onClick: function onClick() {
      return closeModal();
    },
    "data-track-type": "click",
    "data-element-name": "Cancel button"
  })));
};

var _default = UnsavedChangesModal;
exports.default = _default;